export default __webpack_public_path__ + "static/media/icon-info.faafff0e.svg";